// removed by extract-text-webpack-plugin
module.exports = {"Download":"_2bKqWo3o","Icon":"X3q0dsXS","Text":"_2USZ0yRq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/download/download-component.styles.scss
// module id = 288
// module chunks = 0